import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import './Contact.scss';
import ContactModal from '../ContactModal/ContactModal';

function Contact() {
  return (
    <div
      className="Contact d-flex flex-column align-items-center mt-sm-2 flex-grow-1"
    >
      <Row className="d-flex justify-content-center">
        <Col md="8">
          <Card className="mb-3">
            <CardBody className="text-center">
              <p>Jane is available to speak, to groups free of charge. Programs are
                entertainingly informative and can be tailored to the particular interest of the group.</p>
              <p>Contact her at <a href="mailto:janehartenstein@gmail.com">janehartenstein@gmail.com</a> to discuss an
                interesting program for your group.</p>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <div className="d-flex flex-column flex-md-row justify-content-center align-items-center pt-md-4">
        <ContactModal/>
      </div>

    </div>
  )
}

export default Contact;
